import React, { Component } from 'react'
import AdminEvent from '../multi/AdminEvent'

import { db } from '../../../firebase.js'

import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

import Datetime from 'react-datetime'
import '../../../assets/css/react-datetime.css'
import { combineDayAndTimeToFullDate, stripStylesFromHtmlString } from '../../../helpers'

class AdminCalendar extends Component {
  constructor() {
    super()
    this.state = {
      editorState: EditorState.createEmpty(),
			fulldate: "",
			day: "",
			time: "",
      headline: "",
      bodytext: "",
      link: "",
      events: []
    }
  }

  componentDidMount() {
    const dbEvents = db.ref('events')
    dbEvents.on('value', (snapshot) => {
      let events = snapshot.val()
      let newState = []
      for (let event in events) {
        newState.push({
          id: event,
					fulldate: events[event].fulldate,
					day: events[event].day,
					time: events[event].time,
          headline: events[event].headline,
          bodytext: events[event].bodytext,
          link: events[event].link
        })
      }
      this.setState({
        events: newState.sort((a, b) => {return a.fulldate - b.fulldate})
      })
		})
  }

  componentWillUnmount() {
    const dbEvents = db.ref('events')
    dbEvents.off()
  }

  handleEventSubmit = (e) => {
		e.preventDefault()

		//validation sorta
		if (this.state.day === "" || 
				this.state.time === "" ||
				this.state.headline === "" ||
				this.state.link === "") {
			return console.log("error: all fields must be filled out to submit an event")
		}

		//combine the two inputs into some datetime string (for storage in db)
    let fullDateObject = combineDayAndTimeToFullDate(this.state.day, this.state.time)
    
    //strip the inline styles from content - temporary implementation - will strip all selected styles (bold, etc)
    let strippedBodytext = stripStylesFromHtmlString( draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())) )
		
    const dbEvents = db.ref('events')
    const event = {
      fulldate: fullDateObject.getTime(),
      headline: this.state.headline,
      bodytext: strippedBodytext,
      link: this.state.link
    }
    dbEvents.push(event)
    this.setState({
      fulldate: "",
      day: "",
      time: "",
      headline: "",
      bodytext: "",
      link: ""
    })

    //reset the bodytext input after submit
    const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''))
    this.setState({ editorState })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
	}
	
	handleDayChange = (momentObj) => {
		this.setState({
			day: momentObj
		})
	}
	
	handleTimeChange = (momentObj) => {
		this.setState({
			time: momentObj
		})
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    })
  }

	deleteEvent = (event) => {
    const eventRef = db.ref(`/events/${event.id}`);
    eventRef.remove();
  }
	

  render() {
    const { editorState } = this.state

    return (
      <div className="flex flex-column">
				<section className="f4 mb5">
					<div className="pathway f2 mb2 white bg-dark-gray pa3 card">
						ADD EVENT TO CALENDAR
					</div>
          <article className="bg-white card pa2 flex flex-column">
            <div className="mb2 flex flex-column flex-row-ns">
              <Datetime className="open-sans-cond f3 w-100 w-50-ns mb2 mb0-ns pr1-ns"
                        inputProps={{placeholder: "Event date",
                                      className: "b--moon-gray b--solid bw025 w-100",
                                      name: "day"}}
                        timeFormat={false}
                        value={this.state.day}
                        onChange={this.handleDayChange}
                        closeOnSelect={true}/>
              <Datetime className="open-sans-cond f3 w-100 w-50-ns pl1-ns"
                        inputProps={{placeholder: "Start time",
                                      className: "b--moon-gray b--solid bw025 w-100",
                                      name: "time"}}
                        dateFormat={false}
                        timeConstraints={{minutes: {step: 15}}} 
                        value={this.state.time}
                        onChange={this.handleTimeChange}
                        closeOnSelect={true}/>
            </div>

            <div className="mb2 flex flex-column black">
              <input 
                placeholder="Event name"
                name="headline" 
                className="form-control headline-input pa2 open-sans-cond f3 b--moon-gray b--solid bw025" 
                value={this.state.headline} 
                onChange={this.handleChange}/>
            </div>

            <div className="flex flex-column mb2">
              <Editor
                placeholder="Event description"
                editorClassName="form-control open-sans-cond f3 h4 lh-copy ph2 b--moon-gray b--solid bw025 black"
                toolbarClassName="b--moon-gray"
                editorState={editorState}
                onEditorStateChange={this.onEditorStateChange}
                toolbar={{
                  options: ['inline', 'link'],
                  inline: {
                    options: ['bold', 'italic', 'underline']
                  },
                  link: {
                    options: ['link', 'unlink']
                  }
                }}
              />
            </div>

            <div className="mb2 flex flex-column">
              <input 
                placeholder="Link (include http://)"
                name="link" 
                className="form-control pa2 open-sans-cond f3 lh-copy b--moon-gray b--solid bw025" 
                value={this.state.link} 
                onChange={this.handleChange}/>
            </div>

            <div onClick={(e) => {this.handleEventSubmit(e)}} className="dib link pathway pointer self-end bg-animate dim bg-gray ph3 pv2 f3 f2-ns tc near-white">POST TO CALENDAR</div>
					</article>
        </section>
				<section className="w-100 bg-moon-gray flex flex-column">
					<div className="pathway f2 mb2 white bg-dark-gray pa3 card">
						EVENT CALENDAR
					</div>
          {this.state.events.map( (event) => {
            return (
              <AdminEvent event={event} 
                          key={event.id}
                          fulldate={event.fulldate}
                          headline={event.headline}
                          bodytext={event.bodytext}
													link={event.link}
													deleteEvent={this.deleteEvent}
              />
            )
          })}
        </section>

      </div>
    )
  }
}

export default AdminCalendar


// WEBPACK FOOTER //
// ./src/components/admin/pages/AdminCalendar.js